import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box, Table, TableBody, TableRow, TableCell, IconButton,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import MenuItem from "@mui/material/MenuItem";
import {useListEmployeePersonsQuery} from "../store/employee/employeeApi";
import copyObject from "../utils/copyObject";
import {useLazyGetScheduleByPersonQuery, useRemoveScheduleLessonDetailsMutation} from "../store/schedule/scheduleApi";
import DeleteIcon from "@mui/icons-material/Delete";

export default function EmployeeSchedulePage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const {data} = useListEmployeePersonsQuery();
    const [employeesList, setEmployeesList] = useState([]);
    const [startDate, setStartDate] = useState(formatDate(new Date()));
    const [endDate, setEndDate] = useState(formatDate(new Date()));
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [getScheduleRequest] = useLazyGetScheduleByPersonQuery();
    const [schedule, setSchedule] = useState(null);
    const [removeScheduleLessonDetailsRequest] = useRemoveScheduleLessonDetailsMutation();
    
    useEffect(() => {
        if (data !== null && data !== undefined && employeesList?.length === 0) {
            setEmployeesList(copyObject(data.data));
        }
    }, [data]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleLoadData = async () => {
        setIsLoading(true);

        await getScheduleRequest({data: {
                startDate,
                endDate,
                personMasterGuid: selectedEmployee
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setSchedule(copyObject(fulfilled.data));
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            alert('Ошибка');
        });
    };
    
    function dayName(dayNumber) {
        switch (dayNumber) {
            case 1: return 'ПН';
            case 2: return 'ВТ';
            case 3: return 'СР';
            case 4: return 'ЧТ';
            case 5: return 'ПТ';
            case 6: return 'СБ';
            case 7: return 'ВС';
            default: return '?';
        }
    }
    
    async function handleDeletePair(row) {
        console.log('delete', row);
        row.deleted = true;
        setIsLoading(true);
        
        await removeScheduleLessonDetailsRequest({data: {
                scheduleLessonDetailIds: row.scheduleLessonDetailIds
            }}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                row.deleted = true;
                alert('Занятие удалено');
            } else {
                row.deleted = false;
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        }).catch(() => {
            row.deleted = true;
            setIsLoading(false);
            alert('Ошибка');
        });
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Расписание преподавателя`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            {data === null || data === undefined ? <CircularProgress /> : <></>}
                            Расписание преподавателя
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack spacing={2} direction={'row'}>
                                    <Stack>
                                        <Typography fontWeight={'bold'}>Дата с</Typography>
                                        <TextField size={'small'}
                                                   value={startDate}
                                                   onChange={(e) => setStartDate(e.target.value)}
                                                   type={'date'}/>
                                    </Stack>

                                    <Stack>
                                        <Typography fontWeight={'bold'}>Дата по</Typography>
                                        <TextField size={'small'}
                                                   value={endDate}
                                                   onChange={(e) => setEndDate(e.target.value)}
                                                   type={'date'}/>
                                    </Stack>
                                </Stack>

                                <Stack fullWidth>
                                    <Typography fontWeight={'bold'}>Преподаватель</Typography>
                                    <TextField size={'small'}
                                               value={selectedEmployee}
                                               onChange={(e) => setSelectedEmployee(e.target.value)}
                                               fullWidth
                                               select>
                                        {employeesList?.map((item) => {
                                            return <MenuItem value={item.key}>{item.value} (<small> {item.chairs.join(', ')}</small>)</MenuItem>
                                        })}
                                    </TextField>
                                </Stack>
                                
                                <Stack>
                                    <Button variant={'contained'}
                                            size={'small'}
                                            onClick={handleLoadData}
                                            disabled={isLoading}
                                            fullWidth>
                                        {isLoading ? <CircularProgress size={20} /> : <></>}
                                        Просмотр
                                    </Button>
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>

                    {schedule?.sort((l,r) => l.classDate > r.classDate ? 1 : -1).map((day) => {
                        return <Card>
                            <CardContent>
                                <Typography fontWeight={'bold'}>{dayName(day.dayNumber)}, {toDateString(day.classDate)}</Typography>
                                <Typography fontSize={'xx-small'}>{day.weekNumber} неделя</Typography>
                            </CardContent>
                            
                            <TableContainer>
                                <Table size={'small'}>
                                    <TableBody>
                                        {day?.pairs?.sort((l,r) => l.classNumber > r.classNumber ? 1 : -1).map((pair) => {
                                            return <><TableRow>
                                                <TableCell rowSpan={pair.rows.length}>{pair.classNumber} пара</TableCell>
                                                <TableCell>{pair.rows[0]?.disciplineName}</TableCell>
                                                <TableCell>{pair.rows[0]?.lessonTypeName}</TableCell>
                                                <TableCell>
                                                    {pair.rows[0]?.groups} <br />
                                                    {!pair.rows[0]?.hasAttachedGroupFlowTeams
                                                        ? <><br /><Typography fontSize={'smaller'} color={'red'}>Есть непривязанные подгруппы</Typography></>
                                                        :<></>}
                                                    <br />
                                                    <Typography fontSize={'xx-small'}>
                                                        Номер подгруппы по расписанию: {pair.rows[0]?.subgroupNumber} <br />
                                                        {pair.rows[0]?.attachedToTeams}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <small>{pair.rows[0]?.auditorium}</small>
                                                    <br />
                                                    <Button size={'small'} 
                                                            disabled={pair.deleted || isLoading}
                                                            onClick={() => handleDeletePair(pair.rows[0])}
                                                            color={'error'}>Удалить</Button>
                                                </TableCell>
                                            </TableRow>
                                                {pair.rows.slice(1).map((row) => {
                                                    return <TableRow>
                                                        <TableCell>{row.disciplineName}</TableCell>
                                                        <TableCell>{row.lessonTypeName}</TableCell>
                                                        <TableCell>
                                                            {row.groups} <br />
                                                            {!row.hasAttachedGroupFlowTeams
                                                                ? <><br /><Typography fontSize={'smaller'} color={'red'}>Есть непривязанные подгруппы</Typography></>
                                                            :<></>}
                                                            <br />
                                                            <Typography fontSize={'xx-small'}>
                                                                Номер подгруппы по расписанию: {row.subgroupNumber} <br />
                                                                {row.attachedToTeams}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <small>{row.auditorium}</small>
                                                            <br />
                                                            <Button size={'small'}
                                                                    disabled={row.deleted || isLoading}
                                                                    onClick={() => handleDeletePair(row)}
                                                                    color={'error'}>Удалить</Button>
                                                        </TableCell>
                                                    </TableRow>
                                                })}
                                            </>
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    })}

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
